import { Button } from '../../../shared/components';
import { DownloadIcon } from '../../../shared/icons';
import { OperationTimeRecord } from '../../../shared/services/operationTimes/types';
import { exportExcel, exportCsv, exportExcelWithPivot } from '../utils/exportConsolidado';

interface ConsolidadoExportButtonsProps {
  records: OperationTimeRecord[];
  disabled?: boolean;
}

/** Botones de descarga de Consolidado - operan sobre los registros ya filtrados en pantalla. */
export function ConsolidadoExportButtons({ records, disabled }: ConsolidadoExportButtonsProps) {
  const noData = disabled || records.length === 0;
  return (
    <div className="flex flex-wrap gap-3">
      <Button variant="outline" leftIcon={<DownloadIcon width={18} height={18} />} onClick={() => exportExcel(records)} disabled={noData}>
        Descargar Excel
      </Button>
      <Button variant="outline" leftIcon={<DownloadIcon width={18} height={18} />} onClick={() => exportCsv(records)} disabled={noData}>
        Descargar CSV
      </Button>
      <Button variant="outline" leftIcon={<DownloadIcon width={18} height={18} />} onClick={() => exportExcelWithPivot(records)} disabled={noData}>
        Descargar Excel con tabla dinámica
      </Button>
    </div>
  );
}
